module.exports = __webpack_public_path__ + "img/nu.59cd623f.svg";